var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"field"},[_c('div',{class:{
      'checkbox-field': true,
      toggle: _vm.toggle
    }},[_c('input',{ref:"checkbox",staticClass:"visuallyhidden",attrs:{"type":"checkbox","id":_vm.id,"disabled":_vm.disabled},domProps:{"checked":_vm.checked},on:{"change":function($event){return _vm.updateStatus()}}}),_c('label',{attrs:{"for":_vm.id}},[_c('span',[_vm._v(_vm._s(_vm.label))])])])])}
var staticRenderFns = []

export { render, staticRenderFns }